import type { ImgHTMLAttributes } from 'react'
import { imageAssets } from '@/assets/images'

const sources = {
  default: imageAssets.icons.linkedIn.default,
  colored: imageAssets.icons.linkedIn.colored,
}

type LinkIconProps = ImgHTMLAttributes<HTMLImageElement> & {
  variant?: keyof typeof sources
}

function LinkIcon({ variant = 'default', className, ...props }: LinkIconProps) {
  return <img src={sources[variant]} alt="" className={className} {...props} />
}

export default LinkIcon
